'use client';

import { FindingPocScriptActionsBar } from './FindingPocScriptActionsBar';
import type { InternalEnrichedFinding } from '../../types';
import { PocActionsMode } from './poc-actions-mode';

type FindingPocSectionActionsProps = {
  finding: Pick<
    InternalEnrichedFinding,
    'pocScript' | 'pocScriptBlockedByGuardrails' | 'pocScriptGuardrailsFeedback'
  >;
  t: (key: string) => string;
  onGeneratePocScript?: () => void;
  onRegeneratePocScript?: () => void;
  onDownloadPocScript?: () => void;
  onDeletePocScript?: () => void;
  isGeneratingPocScript: boolean;
  isDeletingPocScript?: boolean;
  pocActionsMode?: PocActionsMode;
  mutationsDisabled?: boolean;
  mutationsDisabledTooltip?: string;
};

export function FindingPocSectionActions({
  finding,
  t,
  onGeneratePocScript,
  onRegeneratePocScript,
  onDownloadPocScript,
  onDeletePocScript,
  isGeneratingPocScript,
  isDeletingPocScript = false,
  pocActionsMode = PocActionsMode.Full,
  mutationsDisabled,
  mutationsDisabledTooltip,
}: FindingPocSectionActionsProps) {
  return (
    <FindingPocScriptActionsBar
      finding={finding}
      t={t}
      onGeneratePocScript={onGeneratePocScript}
      onRegeneratePocScript={onRegeneratePocScript}
      onDownloadPocScript={onDownloadPocScript}
      onDeletePocScript={onDeletePocScript}
      isGeneratingPocScript={isGeneratingPocScript}
      isDeletingPocScript={isDeletingPocScript}
      pocActionsMode={pocActionsMode}
      mutationsDisabled={mutationsDisabled}
      mutationsDisabledTooltip={mutationsDisabledTooltip}
    />
  );
}
